import React, {Component} from 'react'

export default class FieldFileInput extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        const {input: {onChange}} = this.props;
        onChange(e.target.files[0])
    }

    render() {
        return (
            <input
                type='file'
                className='form-control-file'
                accept='.jpg, .png, .jpeg'
                onChange={this.onChange}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./web/src/components/common/file/FileUploadComponent.jsx